import { useCenter, useCenterCourses } from "../../../center";
import { PastSessionImportModal, type ImportSubjectKind } from "../../../past_sessions";

interface Props {
    kind: ImportSubjectKind;
    id: string;
    onClose: () => void;
    onImported: () => void;
}

/**
 * Past sessions of the one patient, couple or group whose record is open,
 * filed by its own therapist. At a training centre each may name the module
 * it worked on; the centre's courses are read once this is opened.
 */
export default function RecordPastSessionsImport({ kind, id, onClose, onImported }: Props) {
    const { center } = useCenter();
    const isTraining = center?.type === "training";
    const { courses } = useCenterCourses(center?.id, isTraining);

    return (
        <PastSessionImportModal
            isOpen
            onClose={onClose}
            target={{ kind: "therapist" }}
            subjects={[]}
            fixedSubject={{ kind, id }}
            onImported={onImported}
            courses={
                isTraining && kind !== "couple"
                    ? courses.map((course) => ({
                          id: course.id,
                          label: course.internal_name,
                          modules: course.phases.flatMap((phase) =>
                              phase.id ? [{ id: phase.id, label: phase.name }] : []
                          ),
                      }))
                    : undefined
            }
        />
    );
}
